'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function langSwitchers() {
  var buttonSwitcher = document.querySelectorAll('.js-language-switcher');

  buttonSwitcher.forEach(function (el) {
    document.addEventListener('click', function (event) {
      if (event.target.classList.contains('js-language-switcher')) {
        el.classList.toggle('is-active');
        el.nextElementSibling.classList.toggle('is-active');
      } else {
        el.classList.remove('is-active');
        el.nextElementSibling.classList.remove('is-active');
      }
    });
  });
}

exports.default = langSwitchers;